import React from 'react';
export function SettingsPage() {
  return <div className="p-6" data-id="element-271">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-272">
        Settings
      </h1>
      <div className="text-gray-600 dark:text-gray-400" data-id="element-273">
        Settings panel coming soon...
      </div>
    </div>;
}